__turbopack_context__.v({
  "chargerImage": "ChargerIntroSection-module__h2K7jG__chargerImage",
  "description": "ChargerIntroSection-module__h2K7jG__description",
  "heading": "ChargerIntroSection-module__h2K7jG__heading" + " " + __turbopack_context__.i(515534)["sectionHeading"],
  "mobileCard": "ChargerIntroSection-module__h2K7jG__mobileCard",
  "mobileCardsWrapper": "ChargerIntroSection-module__h2K7jG__mobileCardsWrapper",
  "section": "ChargerIntroSection-module__h2K7jG__section",
  "sequenceCanvas": "ChargerIntroSection-module__h2K7jG__sequenceCanvas",
  "sequenceWrapper": "ChargerIntroSection-module__h2K7jG__sequenceWrapper",
  "stickyContainer": "ChargerIntroSection-module__h2K7jG__stickyContainer",
  "textContainer": "ChargerIntroSection-module__h2K7jG__textContainer" + " " + __turbopack_context__.i(515534)["sectionTextBlock"],
});
